module.exports = __webpack_public_path__ + "static/media/42-6.ea07e81a.mp3";